export default {
	TitleForm: 'Thông báo',
	GroupToday: 'Hôm nay',
	GroupPrevious: 'Trước đó',
	FromDate: 'Từ ngày',
	ToDate: 'Đến ngày',
	FilterBy: 'Lọc theo',
	PlaceHoderSearch: 'Nhập mã giao dịch, số thông báo, tên thông báo',
	Columns: {
		NotificationNo: 'Số thông báo',
		SubmissionCode: 'Mã giao dịch',
		TypeService: 'Loại dịch vụ',
		NotificationName: 'Tên thông báo',
		ReceivedDate: 'Ngày nhận',
		AgencyNotification: 'Cơ quan thông báo'
	},
	DoesNotHaveNotification: 'Chưa có thông báo',
	AutoDownloadInv: (numSuccess, numFail) =>
		`Đã tự động tải từ CQT về thành công ${numSuccess} hóa đơn, ${numFail} hóa đơn tải không thành công`,
	AutoDownloadSuccess: numSuccess => `Đã tự động tải từ CQT về thành công ${numSuccess} hóa đơn`,
	AutoDownloadFail: numSuccess => `Đã tự động tải từ CQT về thất bại ${numSuccess} hóa đơn`,

	Notification: {
		HaveYou: 'Bạn có ',
		NoRemind: 'Không có nhắc nhở',
		Understood: 'Đã hiểu',
		RemindAndFeature: 'Nhắc nhở',
		Views: 'lượt xem',
		ExploreFeatures: 'Khám phá tính năng',
		PlaceHoderSearch: 'Nhập để tìm kiếm',
		Remind: 'Nhắc nhở',
		NewFeature: 'Tính năng mới',
		Extend: 'Mở rộng',
		Colspan: 'Thu gọn',
		InvoiceExpriedDate: ' Hóa đơn đến hạn thanh toán',
		Close: 'Đóng',
		SyncSucess: 'Đồng bộ thành công',
		InvoiceTax: 'hóa đơn từ CQT',
		Total: 'Tổng',
		DownloadSuccess: 'Tải thành công',
		Duplicate: 'Trùng',
		DownloadFail: 'Tải thất bại',
		InvoiceProcessing: 'Hóa đơn đang xử lý',
		InvoiceIgnore: 'Hóa đơn bỏ qua',
		InvoiceWaiting: ' hóa đơn đang kiểm tra chưa có kết quả',
		ConnectLogin: 'Kết nối với tài khoản đăng nhập',
		GovLink: 'hoadondientu.gdt.gov.vn để',
		AutoDownload123:
			'Tự động tải xuống toàn bộ Hóa đơn theo Nghị định 70/2025/NĐ-CP từ Cơ quan Thuế nhanh chóng đầy đủ',
		Skip: 'Bỏ qua',
		Detail: 'Chi tiết',
		CheckNow: 'Kiểm tra ngay',
		ConnectNow: 'Kết nối ngay',
		New: 'Mới',
		FeatureNew: 'Tính năng mới',
		ViewGuide: 'Xem hướng dẫn',
		AccountConnectTaxaxion: 'Tài khoản kết nối CQT tại chi nhánh/phòng ban',
		LostConnect: 'đã bị mất kết nối',
		MST: 'MST',
		InvRevEmail: 'email nhận hóa đơn',
		DateRangeWaiting: dateRange => ` trong ${dateRange} ngày gần nhất`,
		Ignore: 'Bỏ qua',
		InvoiceWaiting1: 'Đang xử lý',
		Fail: 'Thất bại',
		ChangeStatusInvoice: 'Hóa đơn thay đổi trạng thái trong 90 ngày gần đây',
		SupportLicenseHCSN: link =>
			`Do chính sách của MISA, bạn vui lòng liên hệ nhân viên kinh doanh HCSN để được hỗ trợ. <span style='color:#00aab7;cursor: pointer;' onClick=\"window.open('${link}', '_blank')\">Xem tại đây</span>`,
		RiskInvoiceBySupplier: (numInvoice, numberDate) =>
			`Có ${numInvoice} hóa đơn chưa xem có rủi ro trong 90 ngày gần đây`,
		ConnectGovLink: 'Kết nối với hoadondientu.gdt.gov.vn',
		PleaseReloadPage: 'Dữ liệu hệ thống đã bị thay đổi. Vui lòng nhấn F5 để lấy dữ liệu mới nhất',
		Agree: 'Đồng ý',
		ViewList: 'Xem danh sách',
		SystemBanner: {
			ClickToViewDetail: 'Nhấn để xem chi tiết',
			Title: 'Thông báo',
			Close: 'Đóng'
		},
	},

	//Bo sung
	NotHaveNewNotification: 'Bạn chưa có thông báo nào!',
	All: 'Tất cả',
	Action: 'Hoạt động',
	System: 'Hệ thống',
	Discount: 'Khuyến mại',
	TitleNotification: 'Thông báo',
	NotificationFeature: 'Tính năng mới',
	FindMore: 'Tìm hiểu thêm',
	InstructionsForExtension: 'Hướng dẫn gia hạn',
	InstructionsForAdditionalPurchases: 'Hướng dẫn mua thêm',
	SeeTheInstructions: 'Xem hướng dẫn',
	AgoHour: 'giờ trước',
	ProcessingSyncDataTax: 'Đang thực hiện đồng bộ hóa đơn từ Cơ quan Thuế',
	ProcessingSyncDataTaxSuccess: (successAmount, totalAmount) =>
		`Đồng bộ thành công ${successAmount}/${totalAmount} hóa đơn từ CQT`,
	Remind: {
		SuggestOrRecommend: 'Gợi ý, khuyến nghị',
		ConnectTaxMissInvoice: 'Bạn bị thiếu hóa đơn do đâu?',
		InvoiceNotSentToTax: 'Hóa đơn chưa được gửi lên CQT vào thời điểm chương trình tự động tải hóa đơn',
		NotSetSummaryTable: 'Chưa thiết lập lấy hóa đơn từ bảng tổng hợp',
		HasSetSpecificSupplier: 'Đã thiết lập không lấy hóa đơn từ 1 NCC cụ thể',
		HasSetMoveAnotherEmail: 'Hóa đơn tự động chuyển về địa chỉ email khác trong cơ cấu tổ chức do thiết lập',
		NotSetAllTypeInvoice: 'Chưa thiết lập lấy đủ các loại hóa đơn',
		DisconnectTaxAuthority: `Mất kết nối với Cổng thông tin Hóa đơn điện tử (<span style="color: #00aab7">https://hoadondientu.gdt.gov.vn/</span>)`,
		DisconnectTaxaxionTitle: 'Mất kết nối với Cổng thông tin Hóa đơn điện tử',
		DisconnectTaxaxionContent: 'Kết nối với CQT đã bị mất. Vui lòng kiểm tra và kết nối lại',
		DisconnectTaxaxion: {
			LicenseExpired: 'Giấy phép sử dụng đã hết hạn. Vui lòng gia hạn để tiếp tục sử dụng dịch vụ',
			ChangeOrLockAccount: 'Tài khoản kết nối đã bị thay đổi hoặc khóa. Vui lòng kiểm tra và cập nhật thông tin',
			NotPermissionLookupInvoice: 'Tài khoản không có quyền tra cứu hóa đơn. Vui lòng kiểm tra quyền truy cập',
			Default: 'Kết nối với CQT đã bị mất. Vui lòng kiểm tra và kết nối lại',
		},
		ManageSellerRisk: 'Quản lý rủi ro và tình trạng hoạt động của nhà cung cấp?',
		CheckSellerRisk: 'Kiểm tra nhà cung cấp có rủi ro về hóa đơn hay không?',
		NotificationMISA: 'Nhận thông báo từ MISA khi có người bán, nhà cung cấp ngừng hoạt động?',
		ViewSupplierActiveStatus: 'Xem nhanh tình trạng hoạt động của toàn bộ nhà cung cấp, người bán ở đâu?'
	},
	SubmitMessage: {
		ConnectGovLink: 'Cách kết nối với trang hoadondientu.gdt.gov.vn',
		ConnectTaxMissInvoice: 'Tại sao đã kết nối cơ quan thuế nhưng vẫn bị thiếu hóa đơn?',
		InitiAtiveConnect: 'Tại sao đã kết nối cơ quan thuế nhưng vẫn bị thiếu hóa đơn?',
		DisconnectTaxaxion: 'Cách khắc phục mất kết nối với CQT',
		ManageSellerRisk: 'Quản lý rủi ro và tình trạng hoạt động của nhà cung cấp?',
	},
	Assistant: {
		Title: 'Trợ lý thông báo & nhắc nhở',
		TabLatest: 'Mới nhất',
		TabAll: 'Tất cả',
		ChatWithAva: 'Nói chuyện cùng trợ lý AVA',
		NoData: 'Không có thông báo, nhắc mở mới nhất nào',
		HideNotification: 'Ẩn thông báo',
		AskForAva: 'Đặt câu hỏi cho AVA'
	},
	AvaAssitantAIBot: 'Trợ lý số MISA AVA',
	ChatCommuntityMISA: 'Hỏi cộng đồng MISA',
	AmisSupport: 'Chat với nhân viên tư vấn',
	InitiAtiveConnect: 'Chủ động đồng bộ hóa đơn từ CQT về phần mềm',
	DayConnect: (dateNow, dateConnect) =>
		`Hôm nay đã là ngày ${dateNow}, bạn nên chủ động Đồng bộ hóa đơn tháng ${dateConnect} từ CQT để tránh thiếu hóa đơn`,
	InitiAtiveDes: 'Hóa đơn được gửi lên thuế sau ngày lập có thể chưa được đồng bộ tự động, bao gồm:',
	InitiAtiveDesDetail1: 'Hóa đơn điện, nước, viễn thông, ngân hàng, bảo hiểm,...(gửi theo bảng tổng hợp)',
	InitiAtiveDesDetail2: 'Hóa đơn có ngày ký số sau ngày lập hóa đơn',
	ConnectGuildHelp: 'Xem hướng dẫn đồng bộ',
	NotificationTooltip: {
		Title: 'Tính năng',
		TagNew: 'Mới'
	},
	NewInvCQTDetail: count => `Tải thành công ${count} hóa đơn đầu vào từ CQT`,
	NewInvNCCDetail: count => `Tải thành công ${count} hóa đơn đầu vào từ NCC`,
	NewOutCQTDetail: count => `Tải thành công ${count} hóa đơn đầu ra từ CQT`,
	NewNotiEmail: (count, email) => `Vừa nhận được  ${count} email gửi đến ${email}`,
	NewInvoiceChecked: count => `Xử lý xong ${count} hóa đơn đầu vào`,
	NewOutInvoice: count => `Xử lý xong ${count} hóa đơn đầu ra`,
	NewDeclaration: count => `Xử lý xong  ${count} tờ khai hải quan`,
	NewSyncInvoiceDetailFromTax: count => `Đã cập nhật chi tiết hóa đơn thành công cho ${count} hóa đơn`,
	FinishCheckAgain: number => `Có ${number} hóa đơn đầu vào đã được kiểm tra lại`,
	FinishCheckAgainOut: number => `Có ${number} hóa đơn đầu ra đã được kiểm tra lại`,
	InvoiceSyncAgain: count =>
		`Có ${count} hóa đơn đầu vào thay đổi tình trạng cấp mã của Cơ quan thuế sau khi đồng bộ lại từ CQT`,
	OutInvoiceSyncAgain: count =>
		`Có ${count} hóa đơn đầu ra vừa thay đổi tình trạng cấp mã của Cơ quan thuế sau khi đồng bộ lại từ CQT`
};
